import React, { ReactNode } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import styled from 'styled-components';
import theme from '@css/theme';

interface Props {
  onChange: (e: RadioChangeEvent) => void;
  value?: string;
  items: { id: string; element: ReactNode; className?: string }[];
  className?: string;
  disabled?: boolean;
}

const StyledRadio = styled(Radio)`
  .ant-radio-checked {
    .ant-radio-inner {
      border-color: ${theme.color.rsPrimary};
    }
    .ant-radio-inner::after {
      background: ${theme.color.rsPrimary};
    }
  }
`;

export default ({ onChange, value, items, className, disabled = false }: Props) => (
  <Radio.Group onChange={onChange} value={value} className={className}>
    {items.map((i) => (
      <StyledRadio className={i.className} value={i.id} key={i.id} disabled={disabled}>
        {i.element}
      </StyledRadio>
    ))}
  </Radio.Group>
);
